@use "variables" as *;

.imageCreate {
  max-width: 40%;
}

.imageFloatRight {
  float: right;
  margin-left: $spacing-m;
  max-width: 40%;
}

.listItem {
  padding-left: $spacing-l !important;
}

.itemTitle {
  font-size: $fontSize-m;
  font-weight: bold;
}
